'use client';

import { FC, useState } from 'react';
import { useFormStatus } from 'react-dom';

import { getOr } from 'src/utils/getOr';

import { InputFormProps } from './Input.type';
import { InputSelect } from './InputSelect';

/**
 * Select field expected to be used within a React Form
 */
export const InputSelectForm: FC<InputFormProps<typeof InputSelect>> = ({
  id,
  name,
  disabled,
  formState,
  defaultValue,
  ...props
}) => {
  const inputId = id ?? name;
  const error = getOr(formState, `errors.${name}[0]`, null);
  const { pending } = useFormStatus();
  const [value, setValue] = useState<string>(defaultValue ?? '');

  return (
    <InputSelect
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      id={inputId}
      name={name}
      error={error}
      disabled={disabled || pending}
    />
  );
};
